var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"color":"#666","font-size":"14px"}},[_c('div',{staticStyle:{"padding-bottom":"20px"}},[_c('b',[_vm._v("您好！"+_vm._s(_vm.user.nickname))])]),_c('el-card',[_vm._v(" 欢迎使用本系统 "),_c('el-divider'),_vm._v(" 虎虎生威，虎年大吉 ")],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }